import { setExaminerReportData, setExaminerReportModal } from '../../../../../store/workspace/slice';
import { selectExaminerReportData } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { MessageSquareIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useEffect } from 'react';

export default function ExaminerReport() {
    const dispatch = useDispatch();
    const reportData = useSelector(selectExaminerReportData);

    useEffect(() => {
        return () => {
            dispatch(setExaminerReportData(null));
        }
    }, []);

    return (
        <Modal
            size='xxl'
            icon={<MessageSquareIcon />}
            childClassName={styles.wrapper}
            title={`Report - ${reportData?.fullName}`}
            closeFunc={() => dispatch(setExaminerReportModal(false))}
        >
            <div className={styles.status}>
                <span>Multiple choice exam report</span>
            </div>
            <p className={styles.report}>{reportData?.report}</p>
            <div className={styles.actions}>
                <Button
                    text='Close'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setExaminerReportModal(false))}
                />
            </div>
        </Modal>
    )
}
